<template>
  <div id="optIn-settings" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Instant Debit Card</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon small @click="initInstantDebit()" color="#3F4360">
        <img
          :src="computeRefreshLogo"
          alt="Refresh"
          class="height-24"
        />
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout wrap>
        <v-flex lg6>
          <v-img :src="lppLogo" max-height="40" max-width="270" contain></v-img>
        </v-flex>
        <v-flex lg5></v-flex>
        <v-flex lg1>
          <v-btn icon small @click="addDebitCardHandler">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap class="card-packet">
        <v-flex class="card-shadow" lg12 v-for="(item, index) in cardData" :key="index">
          <v-card class="debit-card" :style="index > 0 ? 'margin-top: -50px;' : ''" @click="clickEventHandler(item)">
            <v-layout wrap>
              <v-flex lg6>
                <span class="title">{{ assist.tool.maskSensitiveCharacter('CardNumber', item.maskedCardNumber ) }}</span>
              </v-flex>
              <v-flex lg5>
                <span class="title">{{item.expTime}}</span>
              </v-flex>
              <v-flex lg1 v-if="item.id === selectedId">
                <v-icon color="green" style="font-size: 45px;margin-top: -8px;">check</v-icon>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex class="card-shadow" lg12 v-if="assist.tool.isEmpty(cardData)">
          <v-card class="debit-card"></v-card>
        </v-flex>
        <v-flex lg12 class="transaction-details">
          <v-card class="transaction-table">
            <arb-simple-table
              :desserts="table.desserts"
              :header="table.headers"
              :color="'#f4c887'"
              height="350"
              fontColor="#002B7F"
            ></arb-simple-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import lppLogo from '@/assets/images/logo_lpp.png'
import { InstantApi, ProcessingApi } from '@/api/pandaria'
import { Tool, DataType, Popup } from '@/util/index'
import refreshImg from '@/assets/icons/icon_refresh@3x.png'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'instant-debit',
  props: {
    loan: Object,
    slaveLoan: Object
  },
  data () {
    return {
      assist: {
        tool: tool
      },
      cardData: [],
      selectedId: null,
      table: {
        desserts: [],
        headers: [
          { label: 'Time', template: '{transactionAt}', fieldKey: 'transactionAt', format: 'date' },
          { label: 'Type', template: '{transactionType}', fieldKey: 'transactionType', options: { transactionType: DataType.TransactionTypeOptions } },
          { label: 'Status', template: '{transactionStatus}', fieldKey: 'transactionStatus', options: { transactionStatus: DataType.TransactionStatusEnum } },
          { label: 'Amount', template: '{transactionAmount}', fieldKey: 'transactionAmount', format: 'currency' },
          { label: 'Transaction #', template: '{transactionNo}', fieldKey: 'transactionNo' }
        ]
      },
      lppLogo: lppLogo
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    computeRefreshLogo () {
      return refreshImg
    }
  },
  watch: {
    loanId (val) {
      tool.isNotEmpty(val) && this.initInstantDebit()
    }
  },
  methods: {
    async initInstantDebit () {
      await this.getAllCard()
      await this.searchDebitCard()
    },
    addDebitCardHandler () {
      this.$swal({ type: 'question', text: 'Are you sure to send an email to add the debit card ?' }).then(res => {
        if (res.value) {
          this.addDebitCard()
        }
      })
    },
    clickEventHandler (item) {
      this.selectedId = item.id
      this.enableDebitCard()
      this.searchDebitCard()
    },
    async getAllCard () {
      const $this = this
      await InstantApi.getAllCard(
        this.loanId,
        function (res) {
          if (tool.isNotEmpty(res)) {
            $this.cardData = res
            $this.cardData.map(item => {
              if (item.status === 1) {
                $this.selectedId = item.id
                const cardNo = item.maskedCardNumber.slice(-4)
                $this.store.commit('setCardNo', cardNo)
              }
            })
          }
        }, function () {
          $this.store.commit('setCardNo', 'N/A')
        })
    },
    async searchDebitCard () {
      const $this = this
      tool.isNotEmpty(this.selectedId) &&
      await InstantApi.searchDebitCard(
        this.loanId,
        this.selectedId,
        function (res) {
          $this.table.desserts = res
        },
        function () {
          $this.table.desserts = []
        })
    },
    async addDebitCard () {
      await ProcessingApi.addDebitCard(this.loanId, this.requestSuccessCallBack, this.requestFailureCallBack)
    },
    async enableDebitCard () {
      const formData = new FormData()
      formData.append('id', this.selectedId)
      await InstantApi.enableDebitCard(formData, this.requestSuccessCallBack, this.requestFailureCallBack)
    },
    requestSuccessCallBack () {
      popup.commonPopup({
        type: 'success',
        title: 'Successful',
        showCancelButton: false,
        allowOutsideClick: false
      })
    },
    requestFailureCallBack (err) {
      popup.popupForError(err.message)
    }
  }
}
</script>
<style lang="scss" scoped>
.card-packet {
  margin-top: 15px;
  background-color: #f4c887;
  padding: 15px;
  border-radius: 15px;
  .v-sheet.v-card {
    box-shadow: initial;
  }
  .card-shadow .v-sheet.v-card {
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 45%), 0px 2px 2px 0px rgb(8 7 7 / 64%), 0px 1px 5px 0px rgb(0 0 0 / 78%);
  }
  .debit-card {
    height: 100px;
    margin: 10px 5px;
    padding: 20px;
    border-radius: 15px;
  }
  .transaction-details {
    width: 100%;
    margin-top: -40px;
    .transaction-table {
      padding: 60px 20px 20px 20px;
      background-color: #f4c887;
    }
  }
}
.toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none;
}
</style>
